// ApprovalLogView.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { baseUrl } from "../Univ.js";

function PharmApprovalLogView() {

  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${baseUrl}pharm-approval-log/${id}/`)
      .then(res => setData(res.data))
      .catch(err => console.log(err));
  }, [id]);

  if (!data) return <h5>Loading...</h5>;

  return (
    <div className="container mt-4">

      <h3>Approval Log Details</h3>

      <table className="erp-table-modern">

        <tbody>

          <tr>
            <th>Module</th>
            <td>{data.module}</td>
          </tr>

          <tr>
            <th>Record ID</th>
            <td>{data.record_id}</td>
          </tr>

          <tr>
            <th>Status</th>
            <td>{data.status}</td>
          </tr>

          <tr>
            <th>Approved By</th>
            <td>{data.approved_by}</td>
          </tr>

          <tr>
            <th>Remarks</th>
            <td>{data.remarks}</td>
          </tr>

        </tbody>

      </table>

    </div>
  );
}

export default PharmApprovalLogView;